import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiResponse } from 'types';

import { apiBaseQuery } from 'modules/apiBaseQuery';

import { IEecsCompany, ISearchCompanyPayload } from '../types/eecs-company.type';

export const eecsCompanyApi = createApi({
  reducerPath: 'eecsCompanyApi',
  baseQuery: apiBaseQuery(`${process.env.REACT_APP_API_URL}/v2/api/admin/eecs/company`),
  endpoints: (builder) => ({
    searchCompany: builder.query<ApiResponse<IEecsCompany[]>, ISearchCompanyPayload>({
      query: (params) => ({
        url: `/search`,
        method: 'POST',
        body: params,
      }),
    }),
  }),
});

export const { useLazySearchCompanyQuery } = eecsCompanyApi;
